import { FbFormikSelect } from '@fabricks/ui-components'
import { FormGeneratorConfig } from '../../../utils/formGenerator'
import {
    FbHiddenTextFieldFormElement,
    FbSelectFormElement,
    FbSliderFormElement,
    FbTextFieldFormElement
} from '../../../utils/formElements'
import { BoxSelectFormElement } from '../StorageLocationOptimization/StorageLocationOptimization'

export const neededBoxesFormConfig: FormGeneratorConfig = {
    desiredFuelLevel: {
        component: FbSliderFormElement,
        childProps: {
            label: 'Desired filling level (%)',
            marks: true,
            showValueLabel: 'on',
            key: 'fuel_level_slider',
            min: 0,
            max: 100,
        },
    },
    availableBoxes: {
        component: BoxSelectFormElement,
        childProps: {
            multiple: true,
        },
        validation: {
            type: 'string',
            rules: [
                { name: "required", params: ["Please select at least one box type"]}
            ]
        }
    },
}
